import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../components/nav/navbar";
import Sidebar from "../components/nav/sidebar";
import { useAuth } from "../providers/auth-provider";
import SectionMessage, { SectionMessageAction } from "@atlaskit/section-message";
import Spinner from "../components/ui/spinner";

function DrawerLayout({ children, location, document }) {
    const { user, logout, reload, globalStatus, userStatus, setGlobalStatus, setUserStatus } = useAuth();
    const [inProgress, setInProgress] = useState(document?.in_progress ?? false);

    useEffect(() => {
        setInProgress(document?.in_progress ?? false);
    }, [document?.in_progress]);

    useEffect(() => {
        if (!document) return;
        const channelName = `document-in-progress.${document?.id}`;
        Echo.channel(channelName)
            .listen(".InProgress", (e) => {
                setInProgress(e?.in_progress ?? false);
            });

        return () => Echo.leaveChannel(channelName);
    }, [document]);

    useEffect(() => {
        if (!user) return;
        const channelName = `user-status.${user?.id}`;
        Echo.channel(channelName)
            .listen(".Updated", (e) => {
                setUserStatus(e);
            })
            .listen(".Removed", (e) => {
                setUserStatus(undefined);
            });


        return () => Echo.leaveChannel(channelName);
    }, [user]);

    useEffect(() => {
        if (!user) return;
        const channelName = "status";
        Echo.channel(channelName)
            .listen(".Updated", (e) => {
                setGlobalStatus(e);
            })
            .listen(".Removed", (e) => {
                setGlobalStatus(undefined);
            });


        return () => Echo.leaveChannel(channelName);
    }, [user]);

    return <>
        <ContentWrapper>
            <ContentFlex>
                <Content padding="0px">
                    {children}

                    {inProgress && <>
                        <InProgressWrapper>
                            <Spinner />
                        </InProgressWrapper>
                    </>}
                </Content>
            </ContentFlex>
        </ContentWrapper>
    </>;
}

export default withRouter(DrawerLayout);


const ContentWrapper = styled.div`
min-height: 100vh;
`;
const ContentFlex = styled.div`
min-height: 100vh;
display: flex;
`;

const Content = styled.div`
    padding-left: calc(0px + ${props => props.padding});
    padding-top: calc(${props => props.addPadding ? "56px" : "0px"} + ${props => props.padding} - 20px);
    padding-right: ${props => props.padding};
    padding-bottom: ${props => props.padding};
    background: white;
    width: 100%;
    min-height: 100%;

    position: relative;
`;

function GlobalStatus({ status: { content, type } }) {
    return <GlobalStatusWrapper>
        <SectionMessage appearance={type}>
            <p>{content}</p>
        </SectionMessage>
    </GlobalStatusWrapper>;
}

const GlobalStatusWrapper = styled.div`
width: 100%;
`;



export const InProgressWrapper = styled.div`
position: absolute;
width: 100%;
height: 100%;
background: rgba(255,255,255,0.75);
display: flex;
justify-items: center;
justify-content: center;
align-items: center;
top: 50px;
left: 0px;
z-index: 999999 !important; 
`;